import { useNavigate, useParams } from 'react-router-dom'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { IndicatorsList, Widget, WidgetEmptyState } from '@factorialco/f0-react/dist/experimental'
import { AlertCircle, CheckCircle } from '@factorialco/f0-react/icons/app'
import { MyTrainingsSurveysHeaderDocument, TestScoreDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { i18n } from 'modules/core/testing/i18n'

const Score = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { membership_id, materialized_form_id } = useParams<{
    membership_id: string
    materialized_form_id: string
  }>()
  const { data, loading } = useQuery(TestScoreDocument, {
    variables: {
      membershipId: membership_id ?? '',
      materializedFormId: materialized_form_id ?? '',
    },
  })

  const { data: headerData } = useQuery(MyTrainingsSurveysHeaderDocument, {
    variables: {
      membershipId: membership_id ?? '',
      materializedFormId: materialized_form_id ?? '',
    },
  })
  const form = headerData?.forms.materializedForm
  const trainingId = form?.form?.resourceId

  const percentage = data?.forms?.testScoresConnection?.nodes?.[0]?.percentage
  const isPassed = percentage && percentage >= 50

  const goToAnswers = () => {
    navigate(
      navigation.myTrainings.surveys.detail.fullPath({
        membership_id: membership_id ?? '',
        materialized_form_id: materialized_form_id ?? '',
      })
    )
  }

  const backToCourse = () => {
    navigate(
      navigation.myTrainings.revamp.detailsRevamp.view.overview.fullPath({
        trainingId: String(trainingId),
      })
    )
  }

  return (
    <Box gap="s2" padding="s64">
      <WidgetEmptyState
        title={
          isPassed
            ? i18n.t('trainings.my_surveys.surveys_score.passed.title')
            : i18n.t('trainings.my_surveys.surveys_score.failed.title')
        }
        description={i18n.t('trainings.my_surveys.surveys_score.description')}
        emoji={isPassed ? '🚀' : '🙁'}
      />
      {loading ? (
        <Box width="s400" alignSelf="center" gap="s16">
          <Widget>
            <Box gap="s16" alignSelf="center" alignItems="center">
              <Text size="200">{i18n.t('trainings.my_surveys.surveys_score.loading_results')}</Text>
              <Spinner />
            </Box>
          </Widget>
        </Box>
      ) : (
        <Box width="s400" alignSelf="center" gap="s16">
          <Widget
            header={{
              title: i18n.t('trainings.my_surveys.surveys_score.results'),
            }}
          >
            <IndicatorsList
              items={[
                {
                  content: `${percentage}%`,
                  label: i18n.t('trainings.my_surveys.surveys_score.your_score'),
                },
                {
                  content: isPassed
                    ? i18n.t('trainings.my_surveys.surveys_score.passed.label')
                    : i18n.t('trainings.my_surveys.surveys_score.failed.label'),
                  label: i18n.t('trainings.my_surveys.surveys_score.final_result'),
                  icon: isPassed ? CheckCircle : AlertCircle,
                },
              ]}
            />
          </Widget>
          <Box gap="s16" flexDirection="row" alignSelf="center">
            <F0Button
              variant="primary"
              onClick={backToCourse}
              label={i18n.t('trainings.my_surveys.surveys_score.back_to_course')}
            />
            <F0Button
              variant="default"
              onClick={goToAnswers}
              label={i18n.t('trainings.my_surveys.surveys_score.go_to_answers')}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default Score
